/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CalibrationDataType } from './CalibrationDataType';
import {
    CalibrationDataTypeFromJSON,
    CalibrationDataTypeFromJSONTyped,
    CalibrationDataTypeToJSON,
} from './CalibrationDataType';

/**
 * 
 * @export
 * @interface PtwCloudCalibrationDataDto
 */
export interface PtwCloudCalibrationDataDto {
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    erpDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    calibrationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {CalibrationDataType}
     * @memberof PtwCloudCalibrationDataDto
     */
    calibrationDataType?: CalibrationDataType;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    dataVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    calibratedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    base64Data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCloudCalibrationDataDto
     */
    $type?: PtwCloudCalibrationDataDtoTypeEnum;
}


/**
 * @export
 */
export const PtwCloudCalibrationDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoPtwCloudCalibrationDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwCloudCalibrationDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwCloudCalibrationDataDtoTypeEnum = typeof PtwCloudCalibrationDataDtoTypeEnum[keyof typeof PtwCloudCalibrationDataDtoTypeEnum];



/**
 * Check if a given object implements the PtwCloudCalibrationDataDto interface.
 */
export function instanceOfPtwCloudCalibrationDataDto(value?: unknown): value is PtwCloudCalibrationDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwCloudCalibrationDataDtoTypeEnum)[0];
}

export function PtwCloudCalibrationDataDtoFromJSON(json: any): PtwCloudCalibrationDataDto {
    return PtwCloudCalibrationDataDtoFromJSONTyped(json, false);
}

export function PtwCloudCalibrationDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwCloudCalibrationDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'masterDeviceId': json['masterDeviceId'] == null ? undefined : json['masterDeviceId'],
        'erpDeviceId': json['erpDeviceId'] == null ? undefined : json['erpDeviceId'],
        'calibrationDate': json['calibrationDate'] == null ? undefined : json['calibrationDate'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'] == null ? undefined : json['calibrationCertificateNumber'],
        'calibrationDataType': json['calibrationDataType'] == null ? undefined : CalibrationDataTypeFromJSON(json['calibrationDataType']),
        'dataVersion': json['dataVersion'] == null ? undefined : json['dataVersion'],
        'calibratedBy': json['calibratedBy'] == null ? undefined : json['calibratedBy'],
        'base64Data': json['base64Data'] == null ? undefined : json['base64Data'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwCloudCalibrationDataDtoToJSON(value?: PtwCloudCalibrationDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'masterDeviceId': value['masterDeviceId'],
        'erpDeviceId': value['erpDeviceId'],
        'calibrationDate': value['calibrationDate'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'calibrationDataType': CalibrationDataTypeToJSON(value['calibrationDataType']),
        'dataVersion': value['dataVersion'],
        'calibratedBy': value['calibratedBy'],
        'base64Data': value['base64Data'],
        '$type': value['$type'],
    });
}

